import { createSlice } from '@reduxjs/toolkit';
// Define the initial state using that type
const initialState = {
    selectedProject: null,
    selectedProjectType: null
};
export const slice = createSlice({
    name: 'commonData',
    initialState,
    reducers: {
        setSelectedProjectReducer: (state, action) => {
            state.selectedProject = action.payload;
        },
        setSelectedProjectTypeReducer: (state, action) => {
            state.selectedProjectType = action.payload;
        },
    },
});
export const { setSelectedProjectReducer, setSelectedProjectTypeReducer } = slice.actions;
export default slice.reducer;
